/**
 * FieldValueSource - synchronized with the Prisma enum of the same name.
 *
 * Tags where a field's current value came from, so the UI can show COMPUTED
 * fields as read-only and suggested fields (PARSED, TABLE, AI) as needing a
 * human tap before they count as confirmed. USER is the only source a manual
 * edit ever produces.
 */
export const FIELD_VALUE_SOURCES = ['USER', 'COMPUTED', 'PARSED', 'TABLE', 'AI'] as const;
export type FieldValueSource = (typeof FIELD_VALUE_SOURCES)[number];
